import React, { useEffect } from 'react'

import {
  DcButton,
  PixelCreditCards,
  PixelFactoryContext,
  PixelFlexBox,
  PixelText,
  SectionContent,
  SectionTitle,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'
import { del, get, post } from 'utils/api-routes.util'
import PlusIcon from 'utils/icons/plus-icon'

import AddStripeBillingPaymentMethod from './AddStripeBillingPaymentMethod'
import { IPixelFactory } from '../../../../../../decl.d'

const BillingPaymentMethod = () => {
  interface PaymentInfo {
    account_id: null | number
    account_name: string
    card_number: string
    card_type: string
    expiry_date: string
    id: number
    is_default: boolean
    stripe_payment_method_id: string
  }
  interface PaymentItem {
    id: number
    card_type: string
    card_number: string
    expiry_date: string
    account_name: string
    stripe_payment_method_id: string
    account_id: null
  }

  interface IPaymentData {
    data: PaymentItem[]
  }

  const { showLoader, hideLoader, showSuccess, showFailure, pixelConfirm } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [displayForm, setDisplayForm] = React.useState(false)
  const [billingPaymentMethods, setBillingPaymentMethods] = React.useState<
    PaymentItem[]
  >([])

  const mainSectionRef = React.useRef(null)

  const readData = () => {
    showLoader(mainSectionRef)
    get('/settings/subscription-plans').subscribe(() => {
      hideLoader(mainSectionRef)
    })
  }

  // Fixme: there should be only one read for each component, split this into a separate component
  const readCardData = () => {
    showLoader(mainSectionRef)
    get('/settings/billing/payment-method').subscribe(
      (res: AjaxResponse<IPaymentData | any>) => {
        hideLoader(mainSectionRef)
        const responseData = res.response as IPaymentData
        setBillingPaymentMethods(responseData?.data || [])
      },
    )
  }
  const deleteCard = (cardId) => {
    showLoader(mainSectionRef)
    del(`/settings/billing/${cardId}/payment-method`).subscribe((res: any) => {
      hideLoader(mainSectionRef)
      if (res.response?.data) {
        showSuccess('Card deleted successfully')
        const filteredCards = billingPaymentMethods.filter(
          (card) => card.stripe_payment_method_id !== cardId,
        )
        setBillingPaymentMethods(filteredCards)
      } else {
        showFailure('Something went wrong')
      }
    })
  }
  const setDefault = (cardId) => {
    showLoader(mainSectionRef)
    post(`/settings/billing/${cardId}/default-card`, undefined).subscribe(
      (res: any) => {
        hideLoader(mainSectionRef)
        if (res.response?.data) {
          showSuccess('This card is is now default card')
        } else {
          showFailure('Something went wrong')
        }
      },
    )
  }

  useEffect(() => {
    const currentUrl = window.location.href
    if (currentUrl.includes('payment_intent')) {
      const newUrl = currentUrl.split('?')[0]
      window.location.href = newUrl
    }
  }, [])

  React.useEffect(() => {
    readData()
    readCardData()
  }, [])
  return (
    <>
      <SectionTitle>Payment Methods</SectionTitle>
      <SectionContent style={{ height: 'calc(100% - 40px)', padding: '10px' }}>
        <PixelFlexBox flexDirection={'column'}>
          <PixelFlexBox height="auto" justifyContent="center"></PixelFlexBox>
          {!displayForm && (
            <PixelFlexBox height="auto" justifyContent="flex-end">
              {!billingPaymentMethods?.length && (
                <PixelText style={{ padding: '0 10px  5px 10px' }}>
                  No payment method found
                </PixelText>
              )}
              <DcButton
                style={{ width: '25%' }}
                variant="outline-primary"
                onClick={() => setDisplayForm(true)}
                size="sm"
                margin="0 0 10px 0"
              >
                <PlusIcon /> Add New
              </DcButton>
            </PixelFlexBox>
          )}
          {displayForm && (
            <>
              <AddStripeBillingPaymentMethod
                handleClose={(data) => {
                  if (data?.success) {
                    readCardData()
                  }
                  setDisplayForm(false)
                }}
              />
            </>
          )}

          <PixelFlexBox
            height={'auto'}
            width={'100%'}
            style={{
              alignItems: 'flex-start',
              flexWrap: 'wrap',
              overflow: 'auto',
              padding: '10px 0 10px 0',
            }}
            flexDirection="row"
          >
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '10px',
                justifyContent: 'center',
                flexDirection: 'row',
                width: '100%',
              }}
            >
              {billingPaymentMethods?.map((item: PaymentInfo, index) => {
                return (
                  <PixelCreditCards
                    key={index}
                    onApply={() => {
                      pixelConfirm({
                        title: 'Delete Card',
                        message: 'Are you sure? you want to delete this Card.',
                        onConfirm: () => {
                          deleteCard(item?.stripe_payment_method_id)
                        },
                      })
                    }}
                    isDefault={item.is_default}
                    setCardAsDefault={() => {
                      pixelConfirm({
                        title: 'Set card as default ',
                        message:
                          'Are you sure? you want to set default this Card.',
                        onConfirm: () => {
                          setDefault(item?.stripe_payment_method_id)
                        },
                      })
                    }}
                    CardInfo={{
                      expiry: item?.expiry_date,
                      name: item?.account_name,
                      focused: 'name',
                      number: item?.card_number || '4444',
                      preview: true,
                      short_name: '',
                      card_type:
                        item?.card_type == 'mastercard'
                          ? 'master'
                          : item?.card_type,
                      locale: {
                        valid: 'Valid Thru',
                      },

                      placeholders: {
                        name: 'YOUR NAME HERE',
                      },
                    }}
                  />
                )
              })}
            </div>
          </PixelFlexBox>
        </PixelFlexBox>
      </SectionContent>
    </>
  )
}

export default BillingPaymentMethod
